import { render, staticRenderFns } from "./ApiPayments.vue?vue&type=template&id=1e7cff7e&"
import script from "./ApiPayments.vue?vue&type=script&lang=js&"
export * from "./ApiPayments.vue?vue&type=script&lang=js&"
import style0 from "./ApiPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports